import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import CustomSwitch from '../../../../../../../../BusinessSettings/Components/BussinessCertification/components/CustomSwitch';

const AddCustomField = (props:any) =>
{
	const { handleClose, handleAddField } = props;
	const { language } = useContext(LanguageContext);
	const [ field, setField ] = useState({
		field      : '',
		type       : 'string',
		isRequired : true
	});

	const handleRadio = (event) =>
	{
		setField((prev) => ({ ...prev, type: event.target.value }));
	};

	const handleChange = (e) =>
	{
		setField((prev) => ({ ...prev, field: e.target.value.replace(/\s+/g, ' ') }));
	};

	const handleRequired = (e, checked) =>
	{
		setField((prev) => ({ ...prev, isRequired: checked }));
	};

	const handleAdd = () =>
	{
		const newField = { ...field };

		newField.field = newField.field.trim();

		handleAddField(newField);
		handleClose();
	};

	return (
		<Dialog
			open={props?.open}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle id='alert-dialog-title'>
				<Grid container justifyContent={'space-between'} alignItems={'center'}>
					<Grid item>
						<Typography variant='h6' fontWeight='var(--font500)'>
							{language.addCustomFIeld}
						</Typography>
					</Grid>
					<Grid item sx={{ cursor: 'pointer' }}>
						<RxCross2 onClick={handleClose}/>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container flexDirection={'column'} >
					<Grid item lg={12} sm={12} md={12} xs={12} spacing={2} pb='var(--pixel16)'>
						<Stack direction={'column'}>
							<Typography variant='body2' pb='var(--pixel4)'>{language?.fieldname} </Typography>
							<TextField
								fullWidth
								placeholder={language?.enterFieldname}
								value={field?.field}
								id='Enter Field Name'
								size='small'
								onChange={handleChange}
							/>
						</Stack>
					</Grid>
					<Grid item lg={12} sm={12} md={12} xs={12} spacing={2}>
						<Stack direction={'row'}>
							<FormControl>
								<FormLabel id='demo-row-radio-buttons-group-label' sx={{ fontSize: 'var(--pixel18)', color: 'var(--black)', paddingBottom: '6px' }}>{language.selectInputType}</FormLabel>
								<RadioGroup
									row
									aria-labelledby='demo-row-radio-buttons-group-label'
									name='row-radio-buttons-group'
									value={field?.type}
									onChange={handleRadio}
								>
									<FormControlLabel value='string' control={<Radio/>} label={language.onlyAlphabets} />
									<FormControlLabel value='number' control={<Radio />} label={language.onlyNumeric} />
									<FormControlLabel value='both' control={<Radio />} label={language.both}/>
								</RadioGroup>
							</FormControl>
						</Stack>
					</Grid>

					<Grid item>
						<Stack direction={'row'} alignItems={'center'} pt='var(--pixel4)'>
							<Typography variant='subtitle1' pr={'0.5'}>{language.required}</Typography>
							<CustomSwitch
								toggleEnabled={field?.isRequired}
								handleToggleChange={handleRequired}
							/>
						</Stack>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction='row' p='var(--pixel16)' alignItems={'center'} display={'flex'}>
					<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='outlined' sx={{ textTransform: 'capitalize' }} onClick={handleClose}>
						{language.cancel}</Button>
					<Typography pl='var(--pixel16)'>
						<Button
							onClick={handleAdd}
							disabled={field.field.trim() === ''}
							disableElevation disableFocusRipple disableRipple disableTouchRipple variant='contained'
							sx={{ color         : 'var(--whiteColor)',
								textTransform : 'capitalize'
								// opacity       : field.title !== '' ? '' : '0.5',
								// pointerEvents : field.title !== '' ? 'auto' : 'none'
							}}
						>
							{language.add}
						</Button>
					</Typography>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default AddCustomField;
